// extracted by mini-css-extract-plugin
module.exports = {"list":"bullets-module--list--1hEuA","item":"bullets-module--item--1rjtR","title":"bullets-module--title--b3zXA","text":"bullets-module--text--1dK4R"};